module.exports = {
  messages: {
    CN: {
      search: '搜索用户数',
      capita: '人均搜索次数',
      rank: '排名',
      keyword: '搜索关键词',
      count: '用户数',
      range: '周涨幅',
      introduce: '指标说明'
    },
    HK: {
      search: '搜索用戶數',
      capita: '人均搜索次數',
      rank: '排名',
      keyword: '搜索關鍵詞',
      count: '用戶數',
      range: '周漲幅',
      introduce: '指標說明'
    },
    US: {
      search: 'Search Users',
      capita: 'Per Capita Search',
      rank: 'Rank',
      keyword: 'Keyword',
      users: 'Users',
      range: 'Weekly Range',
      introduce: 'Introduce'
    }
  }
};